import {Component} from "@angular/core";
import {PositionSearchModel} from "../position-search.model";
import {PositionEntityModel} from "../position-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-position-search-page",
    templateUrl: "./position-search-page.component.html",
    providers: [provideSearchModel(PositionSearchModel), provideEntityModel(PositionEntityModel)]
})
export class PositionSearchPageComponent extends AbstractSearchPage {
}
